module.exports = __webpack_public_path__ + "static/img/huanbao.7400b598.png";